const isParentAndPaying = (user: any) => {
  if (!user?.kids?.length) {
    return false;
  }
  return user?.kids.find((item: any) => item.isPaying === true) !== undefined;
};

export default isParentAndPaying;
